import React, { Component } from 'react';
import Button from "../elements/Button";

class ServiceTabDesktop extends Component {

    render() {
        const List = (services) => {
            return services.map((service, key) => {
                return (
                    <li key={key}>{service}</li>
                );
            });
        };

        let halfLength = Math.ceil(this.props.items.length / 2),
            leftSide = this.props.items.splice(0, halfLength),
            rightRide = this.props.items;

        return (
            <div className={'tab-content ' + (this.props.active ? 'active' : '')}>
                <div className="mask mask-left" />
                <div className="mask mask-right" />
                <div className="tab-content-inner">
                    <div className="row">
                        <div className="col-md-3 col-md-offset-3">
                            <ul>
                                {List(leftSide)}
                            </ul>
                        </div>
                        <div className="col-md-3">
                            <ul>
                                {List(rightRide)}
                            </ul>
                        </div>
                    </div>
                    <div className="row centered">
                        <div className="col-xs-12">
                            <Button action={this.props.url} image="/images/btn-learn-more-white.svg" />
                        </div>
                    </div>
                </div>
                <div className="bottom-wave-darkgreen" />
            </div>
        );
    }

}

export default ServiceTabDesktop;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/ServiceBlockDesktop.js